import { OAuthService } from 'angular-oauth2-oidc';
import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { StatusBar, Style } from '@capacitor/status-bar';

@Injectable()
export class AuthConfigService implements OnDestroy {
  private err = false;
  private deepLinkListener?: PluginListenerHandle;

  constructor(
    private readonly oauthService: OAuthService,
    private zone: NgZone,
  ) {
    this.oauthService.setStorage(localStorage);
    if (Capacitor.isNativePlatform()) {
      this.oauthService.configure({
        ...environment.auth,
        openUri: (uri) => {
          void Browser.open({
            url: uri,
            presentationStyle: 'popover',
          });
        },
      });
    } else {
      this.oauthService.configure(environment.auth);
    }
  }

  public init(): void {
    this.oauthService
      .loadDiscoveryDocumentAndTryLogin()
      .catch(() => (this.err = true));
  }

  public async initWithMobile(): Promise<void> {
    await this.registerDeepLinkHandler();

    try {
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();
    } catch {
      this.err = true;
    }
  }

  public get isConfigurationError(): boolean {
    return this.err;
  }

  public ngOnDestroy(): void {
    this.deepLinkListener?.remove();
  }

  private async registerDeepLinkHandler(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    if (this.deepLinkListener) return;

    this.deepLinkListener = await App.addListener('appUrlOpen', ({ url }) => {
      if (!environment.mobile?.deepLink || !url?.startsWith(environment.mobile?.deepLink)) {
        return;
      }

      Browser.close();

      const origin = window.location.origin;
      this.zone.run(() => {
        if (environment.mobile?.deepLink) {
          window.location.href = url.replace(
            environment.mobile?.deepLink,
            origin,
          );
        }
      });
    });

    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
  }
}
